import { apiFetch } from './http';

// ─────────────────────────────────────────────────────────────────────
// MY OWN ACCOUNT.
//
// «Change my password» (#383) lived here and is gone with the password itself
// (#754 stage 3) — `POST /me/password` is removed, and the one surface that
// called it, `/sa`'s «Min konto», went with it. What remains is the UI
// language, which is the same shape of thing: identity-derived, decided by the
// session the transport attaches, with nothing in the request a caller could
// point at somebody else.
//
// The token comes from `clubSession` through apiFetch and is never touched
// here. It lives in memory only, and this module does not change that.
// ─────────────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────────────
// MY OWN UI LANGUAGE (#310).
//
// The second thing this module does, and the same shape as the first: the
// request carries ONE field and no account id, because whose preference
// changes is decided server-side from the session. `GET /me` reads it back.
// ─────────────────────────────────────────────────────────────────────

/**
 * Store the signed-in account's UI language.
 *
 * Returns whether the server has it. A `false` is not fatal and callers
 * deliberately do not undo the switch on it: the language still changes for
 * this session, exactly as an unavailable `localStorage` does not stop the
 * signed-out path. What is lost is only that it follows the person to the
 * next machine, which is a preference failing to persist rather than a
 * command failing to apply.
 *
 * Never throws — an offline browser is a `false`, not an exception for a
 * dropdown handler to catch.
 */
export async function setMyLocale(locale: string): Promise<boolean> {
  try {
    const res = await apiFetch('/me/locale', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ locale }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
